import { Tooltip, TooltipPosition } from '@tableau/widgets';
import React, { ReactElement } from 'react';

import { ExtractEncryptionMode } from '~src/commonInfra/utils/sites/SitePropertyTypes';
import { IUpdateSiteSettingsForSiteAdminParams } from '~src/settings/ServerApi/requests/siteSettings/UpdateSiteSettingsForSiteAdminRequest';
import { UpdateSiteSettingsForSiteAdminRequest } from '~src/settings/ServerApi/requests/siteSettings/UpdateSiteSettingsForSiteAdminRequest';
import { ISiteAdminSettings, ISiteSettingsForSiteAdmin } from '~src/settings/types/ISiteSettingsForSiteAdmin';

import { tooltipCellStyle } from '../styles/ExtractEncryptionSettingsStyles';


export function extractRegionFromKeyIdentifier(keyIdentifier: string): string {
    if (keyIdentifier === null || keyIdentifier === undefined) {
        return '';
    }

    const regex = /^arn:aws:kms:([a-z0-9-]+):\d{12}:key\/[a-f0-9-]+$/;
    const match = keyIdentifier.match(regex);
    return match ? match[1] : '';
}

export function formatDate(dateStr: string): string {
    const date = new Date(dateStr);
    if (dateStr === null || dateStr === undefined || isNaN(date.getTime())) {
      return '';
    }

    const options: Intl.DateTimeFormatOptions = {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    };
    return date.toLocaleString(undefined, options);
}

export function getTooltip(value: string): ReactElement<Tooltip> {
    return (
      <Tooltip
          position={TooltipPosition.Bottom}
          afterDelay={true}
          tooltipContent={value}
          onlyShowWhenClipped={true}
        >
          <div style={tooltipCellStyle}>{value}</div>
      </Tooltip>
    );
  }

export function getSetEncryptionModeEnforcedRequest(siteSettings: ISiteSettingsForSiteAdmin): UpdateSiteSettingsForSiteAdminRequest {
    return new UpdateSiteSettingsForSiteAdminRequest(
        {
            id: (siteSettings as any).id,
            siteAdminSettings: {...siteSettings.siteAdminSettings as ISiteAdminSettings, extractEncryptionMode: ExtractEncryptionMode.ENFORCED},
            subscriptionSettings: siteSettings.subscriptionSettings
        } as IUpdateSiteSettingsForSiteAdminParams);
}

export function getFormattedKeyPolicy(keyPolicy: string): string {
    if (keyPolicy === null || keyPolicy === undefined) {
        return '';
    }

    try {
        return JSON.stringify(JSON.parse(keyPolicy), null, 4);
    } catch {
        return '';
    }
}

export function capitalizeFirstLetter(input: string): string {
    if (!input || input.length === 0) {
        return input;
    }

    return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
}